export default "__VITE_ASSET__DAIRMcl0__"